import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconExplorerComponent } from "./med-icon-explorer.component";

@NgModule({
  declarations: [
    MedIconExplorerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconExplorerComponent,
  ],
})
export class MedIconExplorerModule { }
